(function () {
  "use strict";
  /* Cart sync fix: keeps the header cart-count badge and the standalone
     /cart page in sync with the cart drawer after add/remove/quantity-change
     actions. The original theme code only refreshed the drawer markup itself
     and left the header badge and the full cart page stale. */
  var cartDrawer = document.querySelector("[data-cart-drawer]");
  var mainCartSection = document.querySelector("[data-main-cart]");
  if (!cartDrawer) return;

  function currentDrawerCount() {
    var total = 0;
    cartDrawer.querySelectorAll(".cart-item input[data-key]").forEach(function (input) {
      total += parseInt(input.value, 10) || 0;
    });
    return total;
  }

  function updateCartCountBadges(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "flex" : "none";
    });
  }

  function syncMainCartPage() {
    if (!mainCartSection) return;
    fetch("/?section_id=main-cart")
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-main-cart]");
        if (fresh) mainCartSection.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  if ("MutationObserver" in window) {
    var mo = new MutationObserver(function () {
      updateCartCountBadges(currentDrawerCount());
      syncMainCartPage();
    });
    mo.observe(cartDrawer, { childList: true });
  }
})();
